import { CheckboxGroup as ChakraCheckboxGroup } from '@chakra-ui/react-v2';
import type { CheckboxGroupProps as ChakraCheckboxGroupProps } from '@chakra-ui/react-v2';
import type { Merge } from 'type-fest';

import { Stack, type StackProps } from '@frontend/legacy-components';

import {
  SIZE_TO_VERTICAL_SPACING_MAP,
  SIZE_TO_HORIZONTAL_SPACING_MAP,
  DEFAULT_PROPS,
} from './const';
import type { CheckboxSize } from './types';

export type CheckboxGroupProps = Merge<
  ChakraCheckboxGroupProps,
  { size?: CheckboxSize }
> &
  Pick<StackProps, 'direction' | 'spacing'>;

export const CheckboxGroup = ({
  size,
  direction = DEFAULT_PROPS.direction,
  spacing: spacingProp,
  children,
  ...restProps
}: CheckboxGroupProps) => {
  return (
    <ChakraCheckboxGroup size={size} {...restProps}>
      <Stack
        direction={direction}
        width="fit-content"
        maxWidth="100%"
        // TODO: PP-17161: Fix spacing to use DEFAULT_PROPS.size so that size-
        // specific spacing is applied for implicitly sized CheckboxGroups (i.e.
        // when size is undefined)
        spacing={
          spacingProp || direction === 'row'
            ? SIZE_TO_HORIZONTAL_SPACING_MAP[size]
            : SIZE_TO_VERTICAL_SPACING_MAP[size] // direction 'column', and default
        }
      >
        {children}
      </Stack>
    </ChakraCheckboxGroup>
  );
};
